import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import CreateEvangelistPage from "./evangelistCreate";
import EditEvangelistPage from "./evangelistEdit";
import EvangelistList from "./evangelistsList";
import './evangelistsList.css';

export default class EvangelistsPage extends Component {
  createEvangelistPage = (props) => {
    return <CreateEvangelistPage {...props} selectedEvangelist={this.props.selectedEvangelist}/>
  };

  editEvangelistPage = (props) => {
    return <EditEvangelistPage {...props} selectedEvangelist={this.props.selectedEvangelist}/>
  };

  evangelistsList = (props) => {
    return <EvangelistList {...props} selectedEvangelist={this.props.selectedEvangelist}/>
  };

  render() {
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <Route exact path={`${this.props.match.url}`} render={this.evangelistsList}/>
          <Route exact path={`${this.props.match.url}/new`} render={this.createEvangelistPage}/>
          <Route exact path={`${this.props.match.url}/edit/:evangelistId`} render={this.editEvangelistPage}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/evangelists.js